import { useHandleOutsideClick } from '~/hooks';
import { useRef } from 'react';
import { Loader } from 'semantic-ui-react';
import { arrow, useFloating, offset, autoUpdate } from '@floating-ui/react';
import { PopupMenuProps } from './types';
import { Menu } from 'semantic-ui-react';


export default function PopupMenu({
  trigger,
  onClose,
  isLoading,
  children,
  ...props
}: PopupMenuProps) {
  const arrowRef = useRef(null);
  
  const { refs, x, y, elements: { floating } } = useFloating({
    whileElementsMounted: autoUpdate,
    strategy: 'fixed',
    placement: 'bottom',
    elements: {
      reference: trigger
    },
    middleware: [
      arrow({ element: arrowRef }),
      offset(16)
    ]
  });

  useHandleOutsideClick(refs.floating, () => {
    onClose();
  });

  let top = y;
  if (y < 28) {
    top = 28;
  } else if ((floating as any)?.clientHeight + y > window.innerHeight) {
    top = (window.innerHeight - (floating as any)?.clientHeight) / 2;
  }

  return (
    <>
      <div
        ref={refs.setFloating}
        style={{
          zIndex: 9999,
          transform: `translate(${x}px, ${top}px)`,
          maxHeight: isLoading ? '' : 'calc(100vh - 200px)',
        }}
        {...props}
        className="legacy-popup-container"
      >   
        <Menu vertical className="legacy-popup-menu">
          {isLoading 
            ? <div style={{ height: '34px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Loader active /></div>
            : children}
        </Menu>
      </div>
    </>
    
  );
}